import { createStore, applyMiddleware, combineReducers } from 'redux'
import createSagaMiddleware from 'redux-saga';

import rootSaga from '../sagas'
import exhibFloorReducer from '../reducers/ExhibitorFloor'

const sagaMiddleWare = createSagaMiddleware()

const rootReducer = combineReducers({ exhibFloor: exhibFloorReducer })

export const store = createStore(rootReducer, applyMiddleware(sagaMiddleWare))

sagaMiddleWare.run(rootSaga)
